import Repository from "../Repository";

const resource = "/trackinglists";
export default {
    get() {
        return Repository.get(`${resource}`);
    },
    getTrackingList(trackinglistId) {
        return Repository.get(`${resource}/${trackinglistId}`);
    },
    getTrackingListTemplates() {
        return Repository.get(`${resource}?is_template=1`);
    },
    copyTrackingList(tlId) {
        return Repository.post(`${resource}/${tlId}/copy`);
    },
    createTrackingList(json) {
        return Repository.post(`${resource}`, json);
    },
    updateTrackingList(trackinglistId, json) {
        return Repository.put(`${resource}/${trackinglistId}`, json);
    },
    deleteTrackingList(trackinglistId) {
        return Repository.delete(`${resource}/${trackinglistId}`);
    },
    updateTrackingListFormula(trackinglistId, json) {
        return Repository.put(`${resource}/${trackinglistId}/formula`, json);
    },
    exportTrackingList(trackinglistId, data) {
        return Repository.post(`${resource}/${trackinglistId}/export`, data, {responseType: "blob"});
    }
}